import { render } from "./modal-first-visit.vue?vue&type=template&id=32b35967&scoped=true&ts=true"
import script from "./modal-first-visit.vue?vue&type=script&lang=ts"
export * from "./modal-first-visit.vue?vue&type=script&lang=ts"

import "./modal-first-visit.vue?vue&type=style&index=0&id=32b35967&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b35967"]])

export default __exports__